module.exports = __webpack_public_path__ + "static/media/component-profile-card.51088525.png";